<template>
    <section id="portfolio" class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2>Portfolio<i class="fas fa-file-code right-align"></i></h2>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6" v-for="(item, index) in portfolio" :key="index">
                <!-- Portfolio item card -->
                <div class="portfolio-box">
                    <!-- Item image -->
                    <img :src="`assets/carousel/${item.pictureSource}`" :alt="item.key" class="image">

                    <!-- Card overlay on hover to display information -->
                    <div class="overlay">
                        <div class="text">
                            <!-- Item title -->
                            <div class="title" v-html="item.title"></div>
                            <!-- Item summary -->
                            <div class="summary" v-html="item.summary"></div>

                            <button class="btn btn-white" title="More details" @click="openPortfolioDetails(item.key)">
                                <i class="fas fa-info"></i>
                            </button>
                            <a class="btn btn-white" :href="item.targetLink" target="blank" role="button" title="View source">
                                <i :class="item.actionButton"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            portfolio: [
                {
                    title: 'Urban Sciences Building Office Finder',
                    key: 'usb-office-finder',
                    summary: 'A simple Android navigation app for Newcastle University&rsquo;s Urban Sciences Building.',
                    pictureSource: 'carousel-office-finder.png',
                    actionButton: ['fab', 'fa-github'],
                    targetLink: 'https://github.com/jonathansunarja/USB-Office-Finder-App'
                },
                {
                    title: 'Discover Indonesia Website',
                    key: 'discover-indonesia',
                    summary: 'A website for Discover Indonesia, the biggest annual event of the Indonesian Students Association in Newcastle (PPI Newcastle).',
                    pictureSource: 'carousel-discoverindo.png',
                    actionButton: ['fas', 'fa-globe-asia'],
                    targetLink: 'https://ppinewcastleuk.wixsite.com/discoverindonesia'
                },
                {
                    title: 'WebSiteseeing Tour',
                    key: 'websiteseeing-tour',
                    summary: 'A website covering brief history and uses of HTML, CSS, and JavaScript.',
                    pictureSource: 'carousel-websiteseeing.png',
                    actionButton: ['fab', 'fa-github'],
                    targetLink: 'https://github.com/jonathansunarja/WebSiteSeeing-Tour'
                },
                {
                    title: 'Hotel Report Generator',
                    key: 'hotel-report',
                    summary: 'A Java program to generate a textual report of a hotel and its room vacancies.',
                    pictureSource: 'carousel-hotel.png',
                    actionButton: ['fab', 'fa-github'],
                    targetLink: 'https://github.com/jonathansunarja/Hotel-Report-Generator'
                }
            ]
        }
    },
    methods: {
        ...mapActions(['setPortfolioSelected', 'showPortfolioModal']),
        openPortfolioDetails: function(portfolioSelectedKey){
            this.setPortfolioSelected(portfolioSelectedKey);
            this.showPortfolioModal(true);
        }
    },
    computed: {
        ...mapState(['portfolioShown']),
        triggerPortfolioModal: function(){
            if (this.portfolioShown){
                const el = this.$root.$refs.portfolio.$el;
                $(el).modal({backdrop: 'static', keyboard: false});
            }

            return this.portfolioShown;
        }
    },
    watch: {
        triggerPortfolioModal(){}
    }
}
</script>

<style lang="scss" scoped>
.col-md-12 {
    color: $colour-blue-primary;

    h2 {
        margin-bottom: 2.5rem;
    }
}

.col-md-6 {
    padding: 1rem;

    &:nth-of-type(odd){
         .portfolio-box {
            .overlay {
                left: 100%;
            }

            &:hover .overlay {
                left: 0;
            }
        }
    }

    &:nth-of-type(even){
        .portfolio-box {
            .overlay {
                left: 0;
            }
        }
    }
}

.portfolio-box {
    position: relative;
    width: 100%;

    .image {
        display: block;
        width: 100%;
        height: auto;
    }

    .overlay {
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: $colour-blue-primary;
        width: 0;
        height: 100%;
        transition: .5s ease;

        .text {
            text-align: center;
            color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            opacity: 0;

            .title {
                font-weight: 700;
                font-size: 1.5rem;
            }

            .summary {
                margin: 1rem 0;
            }

            .btn {
                margin: 0 1rem;
                width: 38px;
                border-radius: 50%;
            }
        }
    }

    &:hover {
        .overlay {
            width: 100%;
            opacity: 0.9;
            
            .text {
                width: 75%;
                opacity: 1;
                transition: 4.5s ease;
            }
        }
    }
}
</style>
